import {formatDecimalSeparator} from "src/v2/utils/formatter/format-number"
import {formatDateBr} from "../../utils/convert-fields"

const LONG_COLUMN_MIN_WIDTHS = {
    DataRentabilidadeInicio: 220,
    FatorIndexadorAcumulado: 230,
    FatorJurosAcumulado: 210,
    AtualizacaoMonetaria: 210,
    FinanceiroAmortizacao: 220,
    FinanceiroAmortizacaoExtraordinaria: 300,
    TaxaExpectativaIndexador: 220,
    FatorExpectativaIndexador: 230,
    CalculoDiasIndexador: 200,
    PeriodicidadeAtualizacaoMonetaria: 280,
    MesAniversarioAnualSemestral: 270,
    CalculoFatorCorrecao: 210,
    CasasFatorCorrecao: 200,
    DataAniversarioAnterior: 220,
    DataAniversarioPeriodo: 210,
    DataReferenciaIndice: 200,
    VariacaoIndicePUPAR: 210,
    FatorCorrecaoPUPAR: 220,
    FatorCorrecaoAcumuladoPUPAR: 280,
    FatorCorrecaoAcumuladoPeriodoPUPAR: 330,
    VariacaoIndicePUMTM: 210,
    FatorCorrecaoPUMTM: 220,
    FatorCorrecaoAcumuladoPUMTM: 280,
    FatorCorrecaoAcumuladoPeriodoPUMTM: 330,
    IndexadorCorrecaoPercentual: 270,
    ConversaoFacultativa: 220,
    ConversaoMandatoria: 220,
    DataInicioConversao: 200,
    DataFimConversao: 200,
    DataInicioPreco: 180,
    PremioConversao: 200,
    VolatilidadeAcao: 200,
    NumeroPassos: 180,
    PercentualPUPAR: 200,
}

const buildColumns = (definitions) => definitions.map(([field, headerName, type = "text"]) => ({
    field,
    headerName,
    type,
    minWidth: LONG_COLUMN_MIN_WIDTHS[field] ?? (type === "date" ? 160 : 180),
}))

export const VALIDATION_MEMORY_COLUMNS = {
    pupar: buildColumns([
        ["DataReferencia", "Data referência", "date"],
        ["DataRentabilidadeInicio", "Data rentabilidade início", "date"],
        ["DataEvento", "Data evento", "date"],
        ["DataLiquidacao", "Data liquidação", "date"],
        ["VN", "VN", "decimal"],
        ["VNA", "VNA", "decimal"],
        ["Indexador", "Indexador"],
        ["DataIndexador", "Data indexador", "date"],
        ["Defasagem", "Defasagem"],
        ["FatorIndexadorAcumulado", "Fator indexador acumulado", "decimal"],
        ["TaxaJuros", "Taxa juros", "decimal"],
        ["CalculoDias", "Cálculo dias"],
        ["JurosCapitalizacao", "Juros capitalização"],
        ["FatorJurosAcumulado", "Fator juros acumulado", "decimal"],
        ["AtualizacaoMonetaria", "Atualização monetária", "decimal"],
        ["FinanceiroJuros", "Financeiro juros", "decimal"],
        ["IncorporacaoJuros", "Incorporação juros", "decimal"],
        ["FinanceiroAmortizacao", "Financeiro amortização", "decimal"],
        ["FinanceiroAmortizacaoExtraordinaria", "Financeiro amortização extraordinária", "decimal"],
        ["Pagamento", "Pagamento", "decimal"],
        ["PUPAR", "PUPAR", "decimal"],
    ]),
    pumtm: buildColumns([
        ["DataReferencia", "Data referência", "date"],
        ["DataRentabilidadeInicio", "Data rentabilidade início", "date"],
        ["DataEvento", "Data evento", "date"],
        ["DataLiquidacao", "Data liquidação", "date"],
        ["VN", "VN", "decimal"],
        ["VNA", "VNA", "decimal"],
        ["Indexador", "Indexador"],
        ["DataIndexador", "Data indexador", "date"],
        ["Defasagem", "Defasagem"],
        ["FatorIndexadorAcumulado", "Fator indexador acumulado", "decimal"],
        ["TaxaExpectativaIndexador", "Taxa expectativa indexador", "decimal"],
        ["FatorExpectativaIndexador", "Fator expectativa indexador", "decimal"],
        ["FatorForward", "Fator forward", "decimal"],
        ["TaxaJuros", "Taxa juros", "decimal"],
        ["CalculoDias", "Cálculo dias"],
        ["JurosCapitalizacao", "Juros capitalização"],
        ["FatorJurosAcumulado", "Fator juros acumulado", "decimal"],
        ["FinanceiroJuros", "Financeiro juros", "decimal"],
        ["IncorporacaoJuros", "Incorporação juros", "decimal"],
        ["FinanceiroAmortizacao", "Financeiro amortização", "decimal"],
        ["FinanceiroAmortizacaoExtraordinaria", "Financeiro amortização extraordinária", "decimal"],
        ["AtualizacaoMonetaria", "Atualização monetária", "decimal"],
        ["Pagamento", "Pagamento", "decimal"],
        ["Premio", "Prêmio", "decimal"],
        ["ValorFinal", "Valor final", "decimal"],
        ["TaxaRiskFree", "Taxa risk free", "decimal"],
        ["TaxaMarcacao", "Taxa marcação", "decimal"],
        ["FatorDesconto", "Fator desconto", "decimal"],
        ["ValorMTMFluxo", "Valor MTM fluxo", "decimal"],
    ]),
    fatorCorrecao: buildColumns([
        ["Indexador", "Indexador"],
        ["Defasagem", "Defasagem"],
        ["CalculoDiasIndexador", "Cálculo dias indexador"],
        ["FormulaIndexador", "Fórmula indexador"],
        ["PeriodicidadeAtualizacaoMonetaria", "Periodicidade atualização monetária"],
        ["MesAniversarioAnualSemestral", "Mês aniversário anual semestral"],
        ["ProjecaoInflacao", "Projeção inflação", "boolean"],
        ["InflacaoNegativa", "Inflação negativa", "boolean"],
        ["RecalculoProjecao", "Recálculo projeção", "boolean"],
        ["CalculoFatorCorrecao", "Cálculo fator correção"],
        ["CasasFatorCorrecao", "Casas fator correção"],
        ["DataEvento", "Data evento", "date"],
        ["DataAniversarioAnterior", "Data aniversário anterior", "date"],
        ["DataAniversario", "Data aniversário", "date"],
        ["DataAniversarioPeriodo", "Data aniversário período", "date"],
        ["DataReferenciaIndice", "Data referência índice", "date"],
        ["DataIndexador", "Data indexador", "date"],
        ["dp", "dp"],
        ["dt", "dt"],
        ["VariacaoIndicePUPAR", "Variação índice PUPAR", "decimal"],
        ["FatorCorrecaoPUPAR", "Fator correção PUPAR", "decimal"],
        ["FatorCorrecaoAcumuladoPUPAR", "Fator correção acumulado PUPAR", "decimal"],
        ["FatorCorrecaoAcumuladoPeriodoPUPAR", "Fator correção acumulado período PUPAR", "decimal"],
        ["VariacaoIndicePUMTM", "Variação índice PUMTM", "decimal"],
        ["FatorCorrecaoPUMTM", "Fator correção PUMTM", "decimal"],
        ["FatorCorrecaoAcumuladoPUMTM", "Fator correção acumulado PUMTM", "decimal"],
        ["FatorCorrecaoAcumuladoPeriodoPUMTM", "Fator correção acumulado período PUMTM", "decimal"],
    ]),
    conversibilidade: buildColumns([
        ["DataReferencia", "Data referência", "date"],
        ["Indexador", "Indexador"],
        ["SpreadCredito", "Spread crédito", "decimal"],
        ["TaxaJuros", "Taxa juros", "decimal"],
        ["IndexadorCorrecaoPercentual", "Indexador correção percentual", "decimal"],
        ["ConversaoFacultativa", "Conversão facultativa", "boolean"],
        ["ConversaoMandatoria", "Conversão mandatória", "boolean"],
        ["DataInicioConversao", "Data início conversão", "date"],
        ["DataFimConversao", "Data fim conversão", "date"],
        ["Ticker", "Ticker"],
        ["DataInicioPreco", "Data início preço", "date"],
        ["PrecoConversao", "Preço conversão", "decimal"],
        ["PremioConversao", "Prêmio conversão", "decimal"],
        ["PrecoAcao", "Preço ação", "decimal"],
        ["DataCotacao", "Data cotação", "date"],
        ["VolatilidadeAcao", "Volatilidade ação", "decimal"],
        ["P_up", "P_up", "decimal"],
        ["P_down", "P_down", "decimal"],
        ["NumeroPassos", "Número passos"],
        ["TaxaMTM", "Taxa MTM", "decimal"],
        ["PUMTM", "PUMTM", "decimal"],
        ["PUPAR", "PUPAR", "decimal"],
        ["PercentualPUPAR", "Percentual PUPAR", "decimal"],
        ["Duration", "Duration", "decimal"],
        ["DurationAno", "Duration ano", "decimal"],
    ]),
}

const isAbsent = (value) => value === null || value === undefined || value === ""

const formatDecimalText = (value) => {
    const formattedValue = formatDecimalSeparator(value)
    const [integerPart, decimalPart] = formattedValue.split(",")

    if (decimalPart === undefined) return integerPart

    return `${integerPart},${decimalPart.slice(0, 8)}`
}

export const formatMemoryValue = (value, type = "text") => {
    if (isAbsent(value)) return "-"

    if (type === "boolean") {
        if (value === 1 || value === "1") return "Sim"
        if (value === 0 || value === "0") return "Não"
    }

    if (type === "date") {
        return formatDateBr(value) || String(value)
    }

    if (type === "decimal") return formatDecimalText(value)

    return String(value)
}

export const getVisibleMemoryRows = (rows = []) => rows.slice(0, 10).map((row, index) => ({
    ...row,
    id: row.id ?? row.ID ?? index,
}))
